export default __webpack_public_path__ + "e80fb8cf6b4c0f6c2ca05c8ce0f1b188.png";